import "./tab0.scss";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import * as React from "react";
import {useState} from "react";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import BannerSizeCard from "../../../../../ui/bannersizecard/bannersizecard";
import {BannerSizeCardItem} from "../../../../../modals/types/bannersizecard";
import SingleSelectDropzone from "../../../../../ui/dropzone/singleselect/singleSelectDropzone";
import Matchingadtemplate from "../../../../../ui/adtemplate/matchingadtemplate/matchingadtemplate";

const Tab0 = () => {
    const [showers, setShowers] = useState('M');

    const showersRadioContent: RadioButton[] = [
        {label: "ساخت بنر", currentValue: "M"},
        {label: "آپلود بنر", currentValue: "U"},
    ]

    const bannerSizeItems: BannerSizeCardItem[] = [
        {image: require("../../../../../assets/images/icons/DesktopMobileSize.svg").default, size: "300 × 250"},
        {image: require("../../../../../assets/images/icons/MobileSize.svg").default, size: "300 × 100"},
        {image: require("../../../../../assets/images/icons/DesktopSize.svg").default, size: "970 × 250"},
        {image: require("../../../../../assets/images/icons/DesktopSize.svg").default, size: "120 × 600"},
        {image: require("../../../../../assets/images/icons/DesktopMobileSize.svg").default, size: "468 × 60"},
        {image: require("../../../../../assets/images/icons/DesktopMobileSize.svg").default, size: "728 × 90"},
    ]

    const setRadioContent = (value: string): JSX.Element => {
        if (value === 'M') {
            return (
                <>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="campaignName">عنوان تبلیغ</label>
                            <input type="text" name="campaignName" id="campaignName" className="Campaign-Input mt-2"
                                   placeholder="مثال: کمپین روز مادر"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="campaignDesc">توضیحات تبلیغ</label>
                            <input type="text" name="campaignDesc" id="campaignDesc" className="Campaign-Input mt-2"
                                   placeholder="هرآنچه مربوط به کمپین"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="campaignColor">رنگ برند شما</label>
                            <input type="text" name="campaignColor" id="campaignColor" className="Campaign-Input mt-2"
                                   placeholder="مثال: ffffff"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="campaignBtnTitle">عنوان دکمه</label>
                            <input type="text" name="campaignBtnTitle" id="campaignBtnTitle"
                                   className="Campaign-Input mt-2"
                                   placeholder="مثال: مشاهده"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود تصویر بنر شما"}/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود لوگوی برند"}/>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                            <DotIndicator/>
                            <span>پیش نمایش تبلیغ شما</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-4 col-12">

                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-8 col-12">
                            <Matchingadtemplate type={0}/>
                        </div>
                    </div>
                    <HorizontalDivider/>
                </>
            );
        } else if (value === 'U') {
            return (
                <>
                    {
                        bannerSizeItems.map((bannerSizeItems, index) => {
                            return (
                                <div key={index} className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
                                    <BannerSizeCard image={bannerSizeItems.image} size={bannerSizeItems.size}/>
                                </div>
                            );
                        })
                    }
                    <div className="row mb-5">
                        <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                            <DotIndicator/>
                            <span>پیش نمایش تبلیغ شما</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-3">

                        </div>
                        <div className="col-lg-6 col-md-6 col-9">
                            <img src={require("../../../../../assets/images/photos/AdTemplate1.png")} alt=""
                                 className="img-fluid"/>
                        </div>
                    </div>
                    <HorizontalDivider/>
                </>
            );
        } else {
            return <></>
        }
    }

    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تنظیمات کلی</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="campaignName">عنوان کمپین</label>
                    <input type="text" name="campaignName" id="campaignName" className="Campaign-Input mt-2"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="URL">آدرس صفحه فرود تبلیغ شما</label>
                    <input type="text" name="URL" id="URL" className="Campaign-Input mt-2" placeholder="URL"/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row">
                <div className="d-flex align-items-center mt-3 mb-3">
                    <DotIndicator/>
                    <span>تنظیمات تبلیغ</span>
                </div>
                <div className="col-12 mb-3">
                    <h6 className="mb-3 pt-1 font-light">تنظیمات تبلیغ بنری</h6>
                    <RadioButtons items={showersRadioContent} value={showers} setValue={setShowers}/>
                </div>
                {setRadioContent(showers)}
            </div>
        </div>
    );
}

export default Tab0;